/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAISetPromptConfigViewModel } from "../types/TutorAISetPromptConfigViewModel.ts";

export const tutorAISetPromptConfigViewModelSchema = z.object({
  content: z.string().nullish(),
  isGlobal: z.optional(z.boolean()),
  classStudentId: z.number().int().nullish(),
  personId: z.number().int().nullish(),
}) as unknown as ToZod<TutorAISetPromptConfigViewModel>;
